/**
 * Picks elements from an array at a specified interval.
 *
 * @example
 *
 * const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
 *
 * pickElements(numbers, 2);  // [1, 3, 5, 7, 9]
 * pickElements(numbers, 3);  // [1, 4, 7]
 * pickElements(numbers, 4);  // [1, 5, 9]
 */
const pickElements = <T>(arr: T[], interval: number): T[] => {
  if (arr.length <= 1) return [...arr];
  if (interval <= 0) throw new Error("Interval must be positive");

  const result: T[] = [];

  // Add elements at specified intervals, starting with first element
  for (let i = 0; i < arr.length; i += interval) {
    result.push(arr[i]);
  }

  return result;
};

export default pickElements;
